import * as React from 'react';

export default function ChevronIcon({ deg = 0, ...svgProps }: any) {
    return (
        <svg
            {...svgProps}
            style={{
                width: 10,
                height: 'auto',
                color: 'currentColor',
                transform: deg ? `rotate(${deg}deg)` : undefined,
            }}
            viewBox="0 0 10 10"
        >
            <polygon points="0,0 5,5 0,10" />
        </svg>
    );
}
